import { defineMessages } from 'react-intl';

export default defineMessages({
    requestsMenuTitle: {
        defaultMessage: 'Requests',
        description: 'Requests menu title',
        id: 'sd.customerview.requests.dropdown.menu.title',
    },
});
